import { render, staticRenderFns } from "./MyDetailsSection.vue?vue&type=template&id=c3547c4a"
import script from "./MyDetailsSection.vue?vue&type=script&lang=js"
export * from "./MyDetailsSection.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports